module.exports = __webpack_public_path__ + "img/utförsåkning.739d0737.jpg";